import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { ProductsProvider } from './context/ProductsContext';
import { VideosProvider } from './context/VideosContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import UserInfoModal from './components/UserInfoModal';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import Home from './pages/Home';
import Wishlist from './pages/Wishlist';
import Cart from './pages/Cart';
import Videos from './pages/Videos';
import Chat from './pages/Chat';
import Profile from './pages/Profile';
import About from './pages/About';
import Contact from './pages/Contact';
import Addresses from './pages/Addresses';
import Payment from './pages/Payment';
import Products from './pages/Products';
import ProductDetails from './pages/ProductDetails';
import SearchResults from './pages/SearchResults';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProductForm from './pages/admin/AdminProductForm';
import AdminVideos from './pages/admin/AdminVideos';
import { useAuth } from './context/AuthContext';

function AppContent() {
  const { showUserInfoModal } = useAuth();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminRoute && <Navbar />}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/addresses" element={<Addresses />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/products/:category" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/search" element={<SearchResults />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
          <Route path="/admin/products/new" element={<ProtectedAdminRoute><AdminProductForm /></ProtectedAdminRoute>} />
          <Route path="/admin/products/:productId/edit" element={<ProtectedAdminRoute><AdminProductForm /></ProtectedAdminRoute>} />
          <Route path="/admin/videos" element={<ProtectedAdminRoute><AdminVideos /></ProtectedAdminRoute>} />
        </Routes>
      </div>
      {!isAdminRoute && <BottomNav />}
      {!isAdminRoute && showUserInfoModal && <UserInfoModal />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <ProductsProvider>
          <VideosProvider>
            <Router>
              <AppContent />
            </Router>
          </VideosProvider>
        </ProductsProvider>
      </AdminAuthProvider>
    </AuthProvider>
  );
}

export default App;
